import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { FaShieldAlt, FaBolt, FaHeadset, FaMobileAlt, FaChartLine, FaCreditCard } from "react-icons/fa";

const Features = () => {
  const features = [
    {
      icon: <FaShieldAlt className="text-4xl text-blue-600" />,
      title: "Secure Transactions",
      description: "Bank-grade encryption ensures your transactions are always protected"
    },
    {
      icon: <FaBolt className="text-4xl text-blue-600" />,
      title: "Lightning Fast",
      description: "Instant top-ups with real-time processing and confirmation"
    },
    {
      icon: <FaHeadset className="text-4xl text-blue-600" />,
      title: "24/7 Support",
      description: "Round-the-clock customer service to assist you anytime"
    },
    {
      icon: <FaMobileAlt className="text-4xl text-blue-600" />,
      title: "Mobile First",
      description: "Optimized for the best mobile experience across all devices"
    },
    {
      icon: <FaChartLine className="text-4xl text-blue-600" />,
      title: "Transaction History",
      description: "Detailed history and analytics of all your transactions"
    },
    {
      icon: <FaCreditCard className="text-4xl text-blue-600" />,
      title: "Multiple Payment Options",
      description: "Support for various payment methods and currencies"
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-r from-blue-800 to-blue-600 text-white py-20">
        <div className="absolute inset-0 bg-black opacity-30"></div>
        <div className="container mx-auto px-6 relative z-10">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center max-w-3xl mx-auto"
          >
            <h1 className="text-4xl md:text-5xl font-bold mb-6">
              Powerful Features for Seamless Top-Ups
            </h1>
            <p className="text-xl text-gray-200 mb-8">
              Discover why thousands of users trust our VTU platform for their daily transactions
            </p>
          </motion.div>
        </div>
      </section>

      {/* Main Features Grid */}
      <section className="py-20">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
              Everything You Need in One App
            </h2>
            <p className="text-gray-600 text-lg">
              Comprehensive features designed for your convenience
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {features.map((feature, index) => (
              <motion.div
                key={index}
                whileHover={{ y: -10 }}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-all duration-300"
              >
                <div className="flex flex-col items-center text-center">
                  {feature.icon}
                  <h3 className="text-xl font-bold mt-4 mb-2">{feature.title}</h3>
                  <p className="text-gray-600">{feature.description}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="bg-blue-50 py-20">
        <div className="container mx-auto px-6">
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            className="bg-gradient-to-r from-blue-600 to-blue-800 rounded-2xl p-12 text-center text-white"
          >
            <h2 className="text-3xl md:text-4xl font-bold mb-4">
              Ready to Experience These Features?
            </h2>
            <p className="text-xl mb-8">
              Download our app now and enjoy seamless transactions
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button className="bg-yellow-400 text-blue-900 px-8 py-3 rounded-full font-bold hover:bg-yellow-300 transition duration-300">
                Download Now
              </button>

            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default Features;